var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "content-area__content" },
    [
      _c("vue-title", {
        attrs: { title: _vm.$t("identityProvider:logout:title") }
      }),
      _vm._v(" "),
      _c("h1", { staticClass: "section-title" }, [
        _vm.signedOut
          ? _c("span", { attrs: { "data-test-element": "logout-title" } }, [
              _vm._v(_vm._s(_vm.$t("identityProvider:logout:title")))
            ])
          : _c("span", [
              _vm._v(_vm._s(_vm.$t("identityProvider:logout:confirmTitle")))
            ])
      ]),
      _vm._v(" "),
      _vm.model.showError && !_vm.errors.any()
        ? _c(
            "div",
            {
              staticClass:
                "validation-summary-errors alert alert-danger fade show",
              attrs: {
                role: "alert",
                "data-valmsg-summary": "true",
                "data-test-element": "idp-alert-danger-generic"
              }
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("warning")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.model.errorMessage))])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.signedOut
        ? _c("div", { staticClass: "panel" }, [
            _c("div", { staticClass: "panel-message" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("identityProvider:logout:instructions")) +
                  "\n            "
              ),
              _vm.model.postLogoutRedirectUri
                ? _c(
                    "a",
                    {
                      staticClass: "link",
                      attrs: {
                        href: _vm.model.postLogoutRedirectUri,
                        "data-test-element": "login-link"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("identityProvider:logout:loginLink"))
                      )
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.model.signOutIFrameUrl
              ? _c("iframe", {
                  attrs: {
                    width: "0",
                    height: "0",
                    src: _vm.model.signOutIFrameUrl,
                    title: _vm.$t("identityProvider:logout:loginLink")
                  }
                })
              : _vm._e()
          ])
        : _c("div", [
            _c("form", { ref: "form", attrs: { action: "SignOut/Index" } })
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6d09b3e", { render: render, staticRenderFns: staticRenderFns })
  }
}